<mat-card class="cardWithShadow">
    <mat-card-content class="p-24">

        <div style="text-align: center;" *ngIf="resultsInvoice.results.length == 0">
            <h3>Sin Facturas</h3>
        </div>

        <div class="table-responsive" [ngClass]="{ 'oculto': resultsInvoice.results.length == 0 }">

            <table mat-table matSort
            (matSortChange)="sortOrderChange($event)"
            [dataSource]="dataSource" class="w-100">
                <ng-container matColumnDef="folio">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Folio
                    </th>
                    
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.folio }} </h6>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="nombreCliente">
                    <th mat-header-cell *matHeaderCellDef class="th-header">
                        Nombre
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6> {{element.nombreCliente }} </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaCesion">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Fecha Cesion
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.fechaCesion | date: 'dd-MM-yyyy' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rutCesionario">
                    <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                        Rut Cesionario
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.rutCesionario }}</h6>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="nombreCesionario">
                    <th mat-header-cell *matHeaderCellDef class="th-header">
                        Nombre Cesionario
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6> {{element.nombreCesionario}} </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="montoTotal">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                     Monto Total
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.montoTotal | currency:'CLP':'symbol' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaDocto">
                    <th class="th-header" mat-sort-header mat-header-cell *matHeaderCellDef>
                        Fecha Documento
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6>{{ element.fechaDocto | date: 'dd-MM-yyyy' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rutCliente">
                    <th mat-header-cell *matHeaderCellDef class="th-header">
                        Rut 
                    </th>
                    <td class="mat-body-1" mat-cell *matCellDef="let element">
                        <h6> {{element.rutCliente }} </h6>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row class="cursor-table" *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator (page)="changePaginationTable($event)" [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>